/**
 * AccountAutocomplete — selector de cuenta contable con BÚSQUEDA por código o nombre
 * (reemplaza el <select> simple, poco práctico con planes de cuentas grandes).
 * Reutilizable: configuración de cuentas de nómina, tipos de descuento, bonos, etc.
 */
import { useMemo } from 'react'
import { X } from 'lucide-react'
import { Autocomplete } from '@/components/Autocomplete'

export type AccountOption = { id: string; code: string; name: string }

export function AccountAutocomplete({
  accounts, value, onChange, placeholder = 'Buscar cuenta por código o nombre…',
  id, 'aria-label': ariaLabel,
}: {
  accounts: AccountOption[]
  value: string | null
  onChange: (id: string | null) => void
  placeholder?: string
  /** Para que un `<label htmlFor>` pueda rotularlo: era el único de los cinco
   *  controles compuestos del repo que no lo aceptaba, así que sus 5 usos
   *  quedaban sin nombre accesible y no había forma de dárselo desde afuera. */
  id?: string
  'aria-label'?: string
}) {
  const items = useMemo(() => accounts.map(a => ({ id: a.id, label: `${a.code} — ${a.name}` })), [accounts])
  const display = value ? (items.find(i => i.id === value)?.label ?? '') : ''
  return (
    <div className="relative">
      <Autocomplete
        items={items}
        value={value ?? ''}
        displayValue={display}
        id={id}
        aria-label={ariaLabel}
        onChange={() => { /* selección vía onSelect; limpiar con el botón × */ }}
        onSelect={item => onChange(item.id)}
        placeholder={placeholder}
        freeText={false}
        className="w-full border border-divider rounded-lg pl-3 pr-8 py-2 text-sm focus:ring-2 focus:ring-primary bg-surface"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange(null)}
          title="Quitar"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-content-subtle hover:text-content"
        >
          <X size={14} />
        </button>
      )}
    </div>
  )
}
